export function HelpersElement (pEditor, pHelpers)
{
  this.getCurrentParentNode = (currentRange) =>
  {
    let currentNode = null;

    currentRange = currentRange || pEditor.range.getCurrent();

    if (currentRange)
    {
      if (BEditor.browser.isIE && pEditor.range.selection.getCurrent().type.toUpperCase() === 'CONTROL')
      {
        currentNode = currentRange.item(0).parentNode;
      }
      else
      {
        currentNode = (BEditor.browser.isIE && typeof(currentRange.parentElement) === 'function') ? currentRange.parentElement() : currentRange.startContainer;
      }
    }

    return currentNode;
  };


  this.getCurrentParentNodes = (currentRange) =>
  {
    let currentRangeStart,
        currentRangeEnd,
        currentNodeStart = null,
        currentNodeEnd = null;

    currentRange = currentRange || pEditor.range.getCurrent();

    if (currentRange)
    {
      if (BEditor.browser.isIE)
      {
        if (pEditor.range.selection.getCurrent().type.toUpperCase() === 'CONTROL')
        {
          currentNodeStart = currentRange.item(0).parentNode;
          currentNodeEnd = currentNodeStart;
        }
        else
        {
          currentRangeStart = currentRange.duplicate();
          currentRangeStart.collapse(true);
          currentRangeEnd = currentRange.duplicate();
          currentRangeEnd.collapse(false);

          currentNodeStart = currentRangeStart.parentElement();
          currentNodeEnd = currentRangeEnd.parentElement();
        }
      }
      else
      {
        currentNodeStart = currentRange.startContainer;
        currentNodeEnd = currentRange.endContainer;
      }
    }

    return [currentNodeStart, currentNodeEnd];
  };


  this.getCurrentParentElement = (currentRange) =>
  {
    let currentElement = this.getCurrentParentNode(currentRange);

    if (currentElement)
    {
      while (currentElement && currentElement.nodeType !== 1)
      {
        currentElement = currentElement.parentNode;
      }

      if (!currentElement || currentElement === pEditor.iFrame || currentElement === pEditor.iFrameDoc || currentElement.nodeType === 9)
      {
        currentElement = pEditor.iFrameDoc.body;
      }

      return currentElement;
    }

    return null;
  };


  this.getCurrentParentElements = (currentRange) =>
  {
    let i,
        currentElements = this.getCurrentParentNodes(currentRange);

    if (currentElements)
    {
      for (i = 0; i < currentElements.length; i++)
      {
        while (currentElements[i] && currentElements[i].nodeType !== 1)
        {
          currentElements[i] = currentElements[i].parentNode;
        }

        if (!currentElements[i] || currentElements[i] === pEditor.iFrame || currentElements[i] === pEditor.iFrameDoc || currentElements[i].nodeType === 9)
        {
          currentElements[i] = pEditor.iFrameDoc.body;
        }
      }

      return currentElements;
    }

    return null;
  };


  this.getParentElementByTagsNames = (currentRange, checkTagsNames, checkStopTagsNames) =>
  {
    let currentElement,
        parentElement;

    currentRange = currentRange || pEditor.range.getCurrent();

    if (currentRange)
    {
      currentElement = this.getCurrentParentNode(currentRange);

      if (currentElement)
      {
        parentElement = this.getParentElementFromElementByTagsNames(currentElement, checkTagsNames, checkStopTagsNames);
        return parentElement;
      }
    }

    return null;
  };


  this.getParentElementNameByTagsNames = (currentRange, checkTagsNames, checkStopTagsNames) =>
  {
    let parentElement = this.getParentElementByTagsNames(currentRange, checkTagsNames, checkStopTagsNames);

    return (parentElement && parentElement.nodeName) ? parentElement.nodeName : null;
  };


  this.getParentElementFromElementByTagsNames = (currentElement, checkTagsNames, checkStopTagsNames) =>
  {
    let parentElement;

    if (!checkStopTagsNames)
    {
      checkStopTagsNames = /^BODY$/i;
    }

    if (currentElement)
    {
      parentElement = currentElement;

      while (parentElement && !checkTagsNames.test(parentElement.nodeName.toUpperCase()))
      {
        if (checkStopTagsNames.test(parentElement.nodeName.toUpperCase()) || parentElement.nodeName.toUpperCase() === 'BODY')
        {
          parentElement = null;
          break;
        }

        parentElement = parentElement.parentNode;
      }

      return parentElement;
    }
    else
    {
      return false;
    }
  };


  this.getParentBlockElement = (currentRange, strBlockElement) =>
  {
    let i,
        isStopSearch = false,
        blockElements = strBlockElement.replace(/\s+/g, '').toUpperCase().split(/,/),
        rangeParentElement;

    currentRange = currentRange || pEditor.range.getCurrent();

    if (currentRange)
    {
      if (BEditor.browser.isIE && pEditor.range.selection.getCurrent().type.toUpperCase() === 'CONTROL')
        return null;

      rangeParentElement = (BEditor.browser.isIE && typeof(currentRange.parentElement) === 'function') ? currentRange.parentElement() : currentRange.startContainer;

      while (!isStopSearch && rangeParentElement)
      {
        for (i = 0; i < blockElements.length; i++)
        {
          if (rangeParentElement.nodeName.toUpperCase() === blockElements[i])
          {
            isStopSearch = true;
            break;
          }
        }

        if (!isStopSearch)
        {
          if (rangeParentElement.nodeName.toUpperCase() === 'BODY')
          {
            rangeParentElement = null;
            break;
          }

          rangeParentElement = rangeParentElement.parentNode;
        }
      }
    }

    return isStopSearch ? rangeParentElement : null;
  };


  this.getElementsInRangeByTagsNames = (range, tags, isOnlyFirst = false) =>
  {
    let nodeList = [],
        startContainer = range.startContainer,
        endContainer = range.endContainer,
        startParentElement = this.getParentElementFromElementByTagsNames(startContainer, tags),
        endParentElement = this.getParentElementFromElementByTagsNames(endContainer, tags);

    if (startParentElement && startParentElement === endParentElement)
    {
      nodeList.push(startParentElement);
    }
    else
    {
      const nodesFilter = nd => (tags.test(nd.nodeName) || nd.isSameNode(startContainer) || nd.isSameNode(endContainer)) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP,
            tw = pEditor.iFrameDoc.createTreeWalker(pEditor.iFrameDoc.body, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_TEXT, (BEditor.browser.isIE ? nodesFilter : { acceptNode: nodesFilter }), false);

      let currentNode = tw.currentNode;

      while (currentNode && !((startParentElement && currentNode.isSameNode(startParentElement)) || currentNode.isSameNode(startContainer)))
      {
        currentNode = tw.nextNode();
      }

      while (currentNode && !currentNode.isSameNode(endContainer))
      {
        if (tags.test(currentNode.nodeName))
        {
          nodeList.push(currentNode);

          if (isOnlyFirst)
          {
            break;
          }
        }

        currentNode = tw.nextNode();
      }
    }

    if (nodeList.length === 0)
    {
      if (startParentElement)
      {
        nodeList.push(startParentElement);
      }

      if (endParentElement)
      {
        nodeList.push(endParentElement);
      }
    }

    return nodeList;
  };


  this.getPreviousNode = (stopNode, parentNode, exceptNodeNames = []) =>
  {
    const nodesFilter = nd => exceptNodeNames.includes(nd.nodeName) ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT,
          tw = pEditor.iFrameDoc.createTreeWalker(parentNode, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_TEXT, (BEditor.browser.isIE ? nodesFilter : { acceptNode: nodesFilter }), false);

    let exceptNodes = [],
        parentElement = stopNode.parentNode;

    while (parentElement)
    {
      exceptNodes.push(parentElement);
      parentElement = parentElement.parentNode;
    }

    let currentNode = tw.currentNode;

    while (currentNode && !currentNode.isSameNode(stopNode))
    {
      currentNode = tw.nextNode();
    }

    let isGoToPreviousNode = true;
    currentNode = tw.previousNode();

    while (isGoToPreviousNode && currentNode)
    {
      isGoToPreviousNode = false;

      for (let i = 0; i < exceptNodes.length; i++)
      {
        if (currentNode.isSameNode(exceptNodes[i]))
        {
          isGoToPreviousNode = true;
          break;
        }
      }

      currentNode = tw.previousNode();
    }

    return (currentNode || null);
  };


  this.getNextNode = (startNode, parentNode, exceptNodeNames = []) =>
  {
    const nodesFilter = nd => exceptNodeNames.includes(nd.nodeName) ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT,
          tw = pEditor.iFrameDoc.createTreeWalker(parentNode, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_TEXT, (BEditor.browser.isIE ? nodesFilter : { acceptNode: nodesFilter }), false);

    let currentNode = tw.currentNode;

    while (currentNode && !currentNode.isSameNode(startNode))
    {
      currentNode = tw.nextNode();
    }

    return (currentNode ? tw.nextNode() : null);
  };


  this.getNextTextNode = (node) =>
  {
    const nodesFilter = nd => nd.isSameNode(node) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP,
          tw = (node.nodeType === 3) ?
                 pEditor.iFrameDoc.createTreeWalker(pEditor.iFrameDoc.body, NodeFilter.SHOW_TEXT, null, false) :
                 pEditor.iFrameDoc.createTreeWalker(pEditor.iFrameDoc.body, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_TEXT, (BEditor.browser.isIE ? nodesFilter : { acceptNode: nodesFilter }), false);

    let currentNode = tw.currentNode;

    while (currentNode && !currentNode.isSameNode(node))
    {
      currentNode = tw.nextNode();
    }

    return (currentNode ? tw.nextNode() : null);
  };
}